import React, { useReducer, useCallback, useState, useEffect } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Form,
    FormGroup,
    Label,
    Input,
    Button
} from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

// components
import ButtonLoader from "../mycomponents/Layout/ButtonLoader";
// lib
import handleReducer, { textChange, onBlur } from "../lib/handleChange";
import toastAlert from "../lib/toastAlert";
import isEmpty from "../lib/isEmpty";
// validation
import { editAuthorValid } from "../validation/admin.validation";
// api
import { editAuthor } from "../api/admin";

const initialFormValue = {
    name: "",
    role: ""
};

const AuthorEdit = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();

    const [formValue, setFormValue] = useReducer(handleReducer, initialFormValue);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [loader, setLoader] = useState(false);

    const { _id, name, role } = formValue;

    const handleChange = (e) => textChange(e, setFormValue);

    const handleBlur = (e) => onBlur(e, setTouched);

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        try {
            setLoader(true);
            const { status, errors, message } = await editAuthor({ _id, name, role });
            setLoader(false);

            if (status === true) {
                setFormValue({ type: "RESET", value: initialFormValue });
                toastAlert("success", message, "author");
                setErrors({});
                navigate("/author-list"); // redirect to list page
            } else if (errors) {
                setErrors(errors);
            } else if (message) {
                toastAlert("error", message, "author");
            }
        } catch (err) {
            console.log(err, "submit error");
        }
    }, [formValue, navigate, dispatch]);

    useEffect(() => {
        const { status, errors } = editAuthorValid(formValue);
        if (!status) setErrors(errors);
        else setErrors({});
    }, [formValue]);

    useEffect(() => {
        if (!isEmpty(state)) setFormValue({ type: 'INITIAL_SET', value: state })
    }, [state]);

    return (
        <Row>
            <Col xl={12} lg={12} md={12}>
                <Card>
                    <CardHeader>Edit Author</CardHeader>
                    <CardBody>
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                {/* Left Column */}
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="authorName">Name</Label>
                                        <Input
                                            type="text"
                                            name="name"
                                            id="authorName"
                                            placeholder="Enter full name"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={name}
                                            valid={isEmpty(errors.name)}
                                        />
                                        {touched?.name && <span className="text-danger">{errors.name}</span>}
                                    </FormGroup>

                                    <FormGroup>
                                        <Label for="authorRole">Role</Label>
                                        <Input
                                            type="text"
                                            name="role"
                                            id="authorRole"
                                            placeholder="Enter role"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={role}
                                            valid={isEmpty(errors.role)}
                                        />
                                        {touched?.role && <span className="text-danger">{errors.role}</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <hr />
                            <ButtonLoader
                                loader={loader}
                                color="primary"
                                text="Save"
                                onClick={handleSubmit}
                                disabled={!isEmpty(errors)}
                            />
                        </Form>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default AuthorEdit;